import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import ReactTable from 'react-table';
import {ReactTableDefaults} from 'react-table';
import 'react-table/react-table.css';
import '../resource/css/selectTable.css';
import selectTableHOC from "react-table/lib/hoc/selectTable";
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
const SelectedTable = selectTableHOC(ReactTable);
class DocumentosPago extends Component {
constructor() {
      super();
}  
state = {    
    selection: [],
    showError: true,
    expanded : {},
    data:[]
};  
 fontSize = 11;

 columns = [
     {id:'_selector', show:false},
     {
        Header: 'Producto',
        //pivot: true,
        //accessor: 'riesgo',
        /*accessor: props => {
            return this.props.riesgo;
            },
        id: 'riesgo',*/
        Cell: props => <div style={{ textAlign: "center" }}>{this.props.riesgo}</div>,        
        minWidth: 160,
        style: {
            fontSize: this.fontSize,
        },
    },
    {pivot: true},
    {
    Header: '#Poliza',
    id:'poliza',
    accessor: props => {
    return (props.codProducto+"-"+props.numPoliza);
    },
    //Pivot: <div>ejemplo</div>,
    PivotValue: (props,a,b,c) => {
          this.state.expanded[props.row._viewIndex]=true;
         /* var mg="0px";
          switch (props.row._subRows.length) {
              case 1:  
                    mg = "4px";            
                  break;
              case 2:    
                    mg = "19px";              
                  break;
              case 3:   
                    mg = "34px";               
                  break;          
              default:
                  break;
          }*/
    return (<div style={{ fontWeight: "bold", marginTop:  (4 + (props.row._subRows.length-1)*15)+"px", position: "absolute",marginLeft:"30px"}}>{props.row.poliza}</div>);
    //return props.row.poliza;
    },
    Expander: (props) => {
        return <div></div>;
    },
    minWidth: 161,
    style: {
        fontSize: this.fontSize,
    }
},
{
    Header: 'Documento',
    Cell: props => <div style={{ textAlign: "center" }}>{(props.original.tipoDocumento+"/"+props.original.numDocumento )}</div>,
    minWidth: 156,
    style: {
        fontSize: this.fontSize,
    }
}, {
    Header: 'Monto',
    Cell: props => <div style={{ textAlign: "center" }}>{((props.original.moneda=='USD'?"$.":"S/.") + " " +props.original.monto )}</div>,
    minWidth: 120,
    style: {
        fontSize: this.fontSize,
    }
}, {
    Header: 'Vencimiento',
    //accessor: 'fecVenc',
    Cell: props => <div style={{ textAlign: "center" }}>{props.original.fecVenc}</div>,
    minWidth: 139,
    style: {
        fontSize: this.fontSize
    }
}

];

componentDidMount(){
    
}
componentWillReceiveProps(nextProps){
    if (nextProps.documentoSelected ){
        let selection = ["select-" + nextProps.documentoSelected];
        this.state.selection = selection;
     }else{
        this.state.selection = [];
     }
     this.setState({data: nextProps.mensaje});
}
 render(){     
    ReactTableDefaults.column= {...ReactTableDefaults.column, headerClassName: 'tableRemesaHeader', className:'tableRemesaCell'}; 
    return (<Modal  open={this.props.mostrar || false}
            closeOnEsc={false}
            closeOnOverlayClick={false}
            onClose={this.props.cerrarModal} center classNames={{modalGeneralPoliticas:'modalGeneralPoliticas' }}>
            <p className="metpagos-body-tabs-subtitle">
                De un Total de {this.props.totalDoc} documentos, se muestran los 3 más antiguos por póliza.
                <br/>
                Seleccione:
            </p>
            <br/>
            <SelectedTable
                //listaDocumentos={this.props.mensaje}
                isSelected= {(key) => {
                    return this.state.selection.includes("select-"+key); 
                }                 
                }
                toggleSelection = {(key, shift, row) => {
                    let selection = [...this.state.selection];
                    const keyIndex = selection.indexOf(key);                    
                    selection = [key];
                    this.setState({ selection });
                    console.log(this.props.mensaje);
                    //if("select-"+this.props.mensaje[0].numDocumento==key){
                    if(row.index==1){
                        this.state.showError = false;
                    }else{
                        this.state.showError = true;
                    }
                }}
                selectType = "checkbox" 
                data={this.state.data}
                columns={this.columns}
                //showPagination={false} 
                defaultPageSize={this.props.polizas && Object.keys(this.props.polizas).length>10?10:Object.keys(this.props.polizas).length}
                //defaultPageSize={15}
                minRows= {undefined}
                pivotBy={['poliza']}
                expanded={this.state.expanded}
                previousText={"Anterior"}
                nextText={"Siguiente"}
                loadingText={"Cargando..."}
                noDataText={"No hay datos para mostrar"}
                pageText={"Página"}
                ofText={"de"}
                rowsText={"filas"}
                className="-highlight"
                pageSizeOptions={[5, 10]}
                className="-docum"
            /> 
            <br/>
            <Row>
                <Col className="s12 m6 l6" style={{float: "left"}}>
                    {this.state.showError && 
                    <p className="labelError">*Seleccionar el documento mas antiguo.</p> }
                </Col>
                <Col className="s12 m6 l6" style={{float: "right"}}>
                    <a onClick={(e)=>{
                        this.props.onSelect(this.state.data.filter(obj=>obj._id == this.state.selection[0].split("-")[1])[0]);
                        this.props.cerrarModal();
                    }}
                    style={{float: "right"}}              
                    disabled={!this.state.selection.length ||  this.state.showError} 
                    className="btn-rimac waves-effect waves-light btn">Aceptar</a> 
                </Col>
            </Row>
                
    </Modal>);
 }
}
export default DocumentosPago;


